import { PropertyService } from "@/services";
import { generateFileKey } from "./generateFileKey";

interface UploadFileOptions {
  file: File;

  onProgress?: (progress: number) => void;

  onStatusChange?: (message: string) => void;
}

export interface UploadFileResult {
  url: string;
  metadata: any;
}

export const uploadFile = ({
  file,
  onProgress,
  onStatusChange,
}: UploadFileOptions): Promise<UploadFileResult> => {
  return new Promise(async (resolve, reject) => {
    try {
      onStatusChange?.("Uploading file...");

      const key = generateFileKey(file);

      const { data } = await PropertyService.GetUploadUrl(key);

      const { upload_url, metadata } = data.data;

      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener("progress", (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded / e.total) * 100);
          onProgress?.(percent);
        }
      });

      xhr.addEventListener("load", () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            url: metadata.url,
            metadata,
          });
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      });

      xhr.addEventListener("error", () => {
        reject(new Error("Upload failed due to a network error."));
      });

      xhr.addEventListener("abort", () => {
        reject(new Error("Upload was aborted."));
      });

      xhr.open("PUT", upload_url);
      xhr.setRequestHeader("Content-Type", file.type);
      xhr.send(file);
    } catch (error) {
      reject(error);
    } finally {
      onStatusChange?.("");
    }
  });
};
